/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Strategic_TaglineInputs */

const en_strategic_tagline = /** @type {(inputs: Strategic_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Strategic Tagline`)
};

const es_strategic_tagline = /** @type {(inputs: Strategic_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lema estratégico`)
};

const fr_strategic_tagline = /** @type {(inputs: Strategic_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Slogan stratégique`)
};

const de_strategic_tagline = /** @type {(inputs: Strategic_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Strategischer Tagline`)
};

const ja_strategic_tagline = /** @type {(inputs: Strategic_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`戦略的タグライン (キャッチコピー)`)
};

const zh_strategic_tagline = /** @type {(inputs: Strategic_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`品牌战略标语`)
};

const ar_strategic_tagline = /** @type {(inputs: Strategic_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الشعار الاستراتيجي`)
};

const id_strategic_tagline = /** @type {(inputs: Strategic_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Slogan Strategis`)
};

const it_strategic_tagline = /** @type {(inputs: Strategic_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Slogan Strategico`)
};

const ru_strategic_tagline = /** @type {(inputs: Strategic_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Стратегический слоган`)
};

const pt_strategic_tagline = /** @type {(inputs: Strategic_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Slogan Estratégico`)
};

const ko_strategic_tagline = /** @type {(inputs: Strategic_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`전략적 태그라인`)
};

/**
* | output |
* | --- |
* | "Strategic Tagline" |
*
* @param {Strategic_TaglineInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const strategic_tagline = /** @type {((inputs?: Strategic_TaglineInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Strategic_TaglineInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_strategic_tagline(inputs)
	if (locale === "es") return es_strategic_tagline(inputs)
	if (locale === "fr") return fr_strategic_tagline(inputs)
	if (locale === "de") return de_strategic_tagline(inputs)
	if (locale === "ja") return ja_strategic_tagline(inputs)
	if (locale === "zh") return zh_strategic_tagline(inputs)
	if (locale === "ar") return ar_strategic_tagline(inputs)
	if (locale === "id") return id_strategic_tagline(inputs)
	if (locale === "it") return it_strategic_tagline(inputs)
	if (locale === "ru") return ru_strategic_tagline(inputs)
	if (locale === "pt") return pt_strategic_tagline(inputs)
	return ko_strategic_tagline(inputs)
});